

import { Directive, forwardRef, Attribute } from '@angular/core';
import {
    NG_VALIDATORS, Validator,
    Validators, AbstractControl, ValidatorFn
} from '@angular/forms';

@Directive({
    // tslint:disable-next-line:directive-selector
    selector: '[mobilePattern]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: forwardRef(() => MobilePatternDirective), multi: true }
    ]
})
export class MobilePatternDirective implements Validator {
    constructor( @Attribute('validateEqual') public validateEqual: string) { }

    convertNumbersToLatin(input) {
        if (input) {
            // tslint:disable-next-line:prefer-const
            let inLatin = '', mapping = {
                '۱': '1',
                '۲': '2',
                '۳': '3',
                '۴': '4',
                '۵': '5',
                '۶': '6',
                '۷': '7',
                '۸': '8',
                '۹': '9',
                '۰': '0'
            };

            input = input.toString();
            for (let i = 0; i < input.length; i++) {
                if (mapping[input[i]]) {
                    inLatin += mapping[input[i]];
                } else {
                    inLatin += input[i];
                }

            }

            return inLatin;

        }




    }

    validate(c: AbstractControl): { [key: string]: any } {

        const REGEXP = /^(?:0)\d{10}$/
        return REGEXP.test(this.convertNumbersToLatin(c.value)) ? null : {


            mobilePattern: {
                valid: false
            }
        };



    }
}



// WEBPACK FOOTER //
// C:/Websites/Planeto/PlanetoAngular/src/app/app.component.validator.ts